/* My Trailer.

   THE BUTTON IS THE DRAWER. My Trailer used to jump straight to the VIN
   matched screen with a chevron beside it for this. Two targets in one control
   is a thing people have to learn, so the button opens the drawer and the
   drawer's own Find Parts goes to the parts.

   BOTH COPIES OF THE BUTTON. There are two: one in the bar and one in the
   slide out panel. Only the bar copy was wired up, so on a phone the button
   still went to the extension's VIN matched screen. The panel copy doubles as
   the call to action when nothing has been searched yet, so with an empty log
   its click is left alone and it goes to the VIN field as it always did.

   A DEFAULT IS NOT A CHOICE. The filters come up on Sport Range, Super Sport,
   2026 with nobody having touched them, and the extension writes that straight
   to trailerData on load. Logging it meant the drawer opened claiming a trailer
   the customer had never picked, with a Find Parts button under it. A browsed
   trailer is now only recorded once something on the page has actually been
   used, and USED MEANS A REAL GESTURE: the test is event.isTrusted, because the
   extension dispatches its own change events while it populates those selects
   and the first version of this counted them as the customer choosing.

   A VIN ROW AND A BROWSED ROW ARE DIFFERENT THINGS. A VIN row shows the
   number, because that is a fact about one physical machine. A browsed row
   carries a quiet Browsed tag instead. Collapsing the two is what produced the
   merged trailer bug.

   PICKING A ROW PROMOTES IT, IT DOES NOT NAVIGATE. The row animates up into
   the card and the list closes over the gap, so you can look through three
   trailers without leaving. Find Parts commits. VIEWING holds that choice and
   is deliberately not written to the log: the log records what was searched,
   and browsing the drawer is not searching.

   THE RANGE COMES FROM THE MATRIX, not from the last filter selection. Reading
   it from fxTrailerPick meant a SHIFTR trailer inherited whatever range was
   picked before it and sat there labelled Sport Range. */
(function () {
  'use strict';

  var KEY = 'fxTrailerLog';
  var PENDING = 'fxReplayVin';
  var SPECS_URL = '/apps/vin-search/modelSpecs';
  var MAX = 8;
  var built = false;
  var frame = 0;
  var viewing = null;
  var chosen = false;

  function read(k, fallback) {
    try { return JSON.parse(window.localStorage.getItem(k) || 'null') || fallback; }
    catch (e) { return fallback; }
  }
  function write(k, v) {
    try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function norm(s) {
    return String(s == null ? '' : s).toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
  }

  /* Brand tokens are not words, so title case leaves them alone. Without this
     the drawer reads Shiftr 1883, which is not how the brand is written. */
  var KEEP = { SHIFTR: 1, FUTURA: 1, RT500: 1, VIN: 1 };

  function pretty(s) {
    return String(s || '').replace(/_/g, ' ').toLowerCase()
      .replace(/\S+/g, function (w) {
        var up = w.toUpperCase();
        if (KEEP[up.replace(/[^A-Z0-9]/g, '')]) return up;
        return w.charAt(0).toUpperCase() + w.slice(1);
      }).trim();
  }
  function ago(ts) {
    var d = Date.now() - (ts || 0);
    var day = 86400000;
    if (d < 3600000) return 'Just now';
    if (d < day) return 'Today';
    if (d < day * 2) return 'Yesterday';
    if (d < day * 7) return Math.round(d / day) + ' days ago';
    if (d < day * 14) return 'Last week';
    return Math.round(d / (day * 7)) + ' weeks ago';
  }

  /* The one authoritative answer for which range a model belongs to. */
  function rangeOf(modelName) {
    try {
      var list = (window.TRAILER_SELECTOR_MATRIX || {}).models || [];
      for (var i = 0; i < list.length; i++) {
        if (norm(list[i].name) === norm(modelName)) {
          var r = list[i].ranges;
          return pretty(Array.isArray(r) ? r[0] : r);
        }
      }
    } catch (e) {}
    return '';
  }

  /* ---- figures, from the same proxy the model sheet reads ------------- */

  var specs = null;
  function loadSpecs(then) {
    if (specs) { then(); return; }
    if (!window.fxSpecsPromise) {
      window.fxSpecsPromise = fetch(SPECS_URL, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var map = {};
          ((j && j.specs) || []).forEach(function (m) {
            var row = {};
            (m.groups || []).forEach(function (g) {
              (g.rows || []).forEach(function (r) {
                var lab = String(r.label || '').toLowerCase();
                if (lab.indexOf('deck length') > -1) row.len = r.value;
                else if (lab.indexOf('deck width') > -1) row.wid = r.value;
                else if (lab.indexOf('load capacity') > -1) row.cap = r.value;
              });
            });
            map[norm(m.modelName)] = row;
          });
          return map;
        })
        .catch(function () { return {}; });
    }
    window.fxSpecsPromise.then(function (m) { specs = m || {}; then(); });
  }

  function splitVal(raw) {
    var m = /^(.*?)\s*\(([^)]+)\)\s*$/.exec(String(raw || ''));
    return m ? { fig: m[1].trim(), note: m[2].trim() } : { fig: String(raw || ''), note: '' };
  }
  function figure(label, raw) {
    if (!raw) return null;
    var p = splitVal(raw);
    var cell = el('div');
    cell.appendChild(el('b', null, p.fig.replace(/(\d)'(\d)/g, "$1' $2")));
    cell.appendChild(el('span', null, p.note ? label + ', ' + p.note : label));
    return cell;
  }
  function fillFigs(host, name) {
    if (!specs) { loadSpecs(function () { fillFigs(host, name); }); return; }
    var row = specs[norm(name)];
    if (!row) { host.textContent = ''; return; }
    host.textContent = '';
    [figure('Deck Length', row.len), figure('Deck Width', row.wid), figure('Load Capacity', row.cap)]
      .forEach(function (c) { if (c) host.appendChild(c); });
  }

  /* ---- the record ----------------------------------------------------- */

  function current() {
    var d = read('trailerData', null);
    if (!d || !d.modelName) return null;
    var pick = read('fxTrailerPick', null);
    var vin = String(d.vinNumber || '').trim();
    var year = String(d.vinModelYear || (pick && pick.modelYear) || '').trim();
    return {
      id: vin ? 'v:' + vin : 'm:' + d.modelName + '|' + year,
      kind: vin ? 'vin' : 'browse',
      vin: vin,
      model: pretty(d.displayModelName || d.modelName),
      year: year,
      range: rangeOf(d.modelName) || pretty(d.modelType || ''),
      img: d.trailerImage || '',
      at: Date.now()
    };
  }

  /* Re-prettified on the way out, so rows written before a brand token was
     added to KEEP correct themselves on the next read rather than sitting
     there misspelled until that model is searched again. */
  function log() {
    var list = read(KEY, []);
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].model) list[i].model = pretty(list[i].model);
    }
    return list;
  }

  function remember(rec) {
    if (!rec) return;
    var list = log();
    var keep = null;
    list = list.filter(function (r) {
      if (r.id === rec.id) { keep = r; return false; }
      return true;
    });
    if (keep && keep.nick) rec.nick = keep.nick;
    list.unshift(rec);
    write(KEY, list.slice(0, MAX));
  }

  /* ---- replay --------------------------------------------------------- */

  function replayVin(vin) {
    var input = document.querySelector('.vin-hero-vin-input');
    var go = document.querySelector('.vin-search-hero-btn--vin');
    if (!input || !go) {
      try { window.sessionStorage.setItem(PENDING, vin); } catch (e) {}
      window.location.href = '/';
      return;
    }
    input.focus();
    input.value = vin;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () { go.click(); }, 60);
  }

  /* Find Parts has to find parts. This used to set the three filters and then
     scroll the page to them, which left the customer looking at the line-up
     again with no results and no idea what had happened. It now presses the
     pick section's own Find Parts once the filters have settled, which is the
     path the extension already supports, and only falls back to scrolling if
     that control is not on the page. */
  function replayBrowse(rec) {
    var bar = document.querySelector('.vin-hero-pickbar');
    if (!bar) { window.location.href = '/'; return; }
    var sels = bar.querySelectorAll('select');
    var wanted = [rec.range, rec.model, rec.year];
    var i = 0;

    function finish() {
      var find = document.querySelector('[data-ident-find]');
      if (find) { find.click(); return; }
      var pick = document.querySelector('.vin-hero-pick');
      if (pick) pick.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    (function step() {
      if (i >= sels.length || i >= wanted.length) { setTimeout(finish, 280); return; }
      var sel = sels[i], want = String(wanted[i] || '').toUpperCase();
      if (want) {
        for (var o = 0; o < sel.options.length; o++) {
          var opt = sel.options[o];
          if (String(opt.text).toUpperCase() === want || String(opt.value).toUpperCase() === want) {
            sel.selectedIndex = o;
            sel.dispatchEvent(new Event('input', { bubbles: true }));
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
      i++;
      setTimeout(step, 140);
    })();
  }

  function commit(rec) {
    close();
    if (rec.kind === 'vin' && rec.vin) replayVin(rec.vin);
    else replayBrowse(rec);
  }

  /* ---- the drawer ----------------------------------------------------- */

  var root, listHost, nowHost;

  function close() {
    if (root) root.classList.remove('is-open');
    document.documentElement.classList.remove('fx-recall-lock');
  }
  function open() {
    viewing = null;
    render(false);
    if (root) root.classList.add('is-open');
    document.documentElement.classList.add('fx-recall-lock');
    var f = root && root.querySelector('.fx-rc__x');
    if (f) f.focus();
  }

  var GLYPH = '<svg viewBox="0 0 48 22" aria-hidden="true" focusable="false">' +
    '<path d="M3 9 H12 L15 7" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round"/>' +
    '<rect x="15" y="6" width="30" height="4" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
    '<circle cx="24" cy="15" r="3.4" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
    '<circle cx="34" cy="15" r="3.4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

  var PEN = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path d="M2 11.4 L10.6 2.8 L13.2 5.4 L4.6 14 L1.6 14.4 Z" fill="none" stroke="currentColor" ' +
    'stroke-width="1.4" stroke-linejoin="round"/><path d="M9.2 4.2 L11.8 6.8" stroke="currentColor" ' +
    'stroke-width="1.4" stroke-linecap="round"/></svg>';

  function blank(s) {
    s.textContent = '';
    s.classList.add('is-blank');
    s.innerHTML = GLYPH;
    return s;
  }

  function thumb(rec, cls, src) {
    var s = el('span', cls);
    var mapped = window.fxRenderFor ? window.fxRenderFor(rec.model) : '';
    var url = mapped || src || rec.img || '';
    if (mapped) {
      s.setAttribute('data-fx-white', '1');
      if (window.fxLenFor) s.style.setProperty('--fx-len', String(window.fxLenFor(rec.model) || 1));
    }
    if (!url) return blank(s);
    var im = document.createElement('img');
    im.src = url;
    im.alt = '';
    im.loading = 'lazy';
    im.addEventListener('error', function () { blank(s); });
    s.appendChild(im);
    return s;
  }

  function liveImg(rec) {
    var d = read('trailerData', null);
    var cur = current();
    if (cur && rec && cur.id === rec.id && d && d.trailerImage) return d.trailerImage;
    return '';
  }

  function nameOf(rec) { return rec.nick || ((rec.year ? rec.year + ' ' : '') + rec.model); }

  function rename(rec, labelNode) {
    var input = el('input', 'fx-rc__rename');
    input.type = 'text';
    input.value = rec.nick || '';
    input.placeholder = nameOf(rec);
    input.setAttribute('aria-label', 'Name this trailer');
    labelNode.replaceWith(input);
    input.focus();
    input.select();
    function commitName() {
      var list = log();
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === rec.id) {
          var v = input.value.trim();
          if (v) list[i].nick = v; else delete list[i].nick;
        }
      }
      write(KEY, list);
      render(false);
    }
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); commitName(); }
      if (e.key === 'Escape') render(false);
    });
    input.addEventListener('blur', commitName);
  }

  /* A pencil on its own was not saying what it did, so the card spells it out
     and only the rows, where space is tight, keep the icon alone. */
  function nameBtn(rec, labelNode) {
    var b = el('button', 'fx-rc__name-btn');
    b.type = 'button';
    b.innerHTML = PEN;
    b.appendChild(document.createTextNode(rec.nick ? 'Rename this trailer' : 'Give this trailer a name'));
    b.addEventListener('click', function (e) { e.stopPropagation(); rename(rec, labelNode); });
    return b;
  }

  function pencil(rec, labelNode) {
    var b = el('button', 'fx-rc__pen');
    b.type = 'button';
    b.title = 'Give this trailer a name';
    b.setAttribute('aria-label', 'Give this trailer a name');
    b.innerHTML = PEN;
    b.addEventListener('click', function (e) { e.stopPropagation(); rename(rec, labelNode); });
    return b;
  }

  function render(animate) {
    if (!root) return;
    var list = log();
    var top = viewing || list[0] || null;

    var vb = root.querySelector('.fx-rc__btn');
    if (vb) vb.textContent = list.length ? 'Search a different VIN' : 'Search by VIN';

    nowHost.textContent = '';
    listHost.textContent = '';

    /* Nothing chosen yet. One state, not a card pretending a default filter is
       somebody's trailer. */
    if (!top) {
      var none = el('div', 'fx-rc__empty');
      none.appendChild(el('h5', null, 'No trailer saved yet'));
      none.appendChild(el('p', null, 'Look yours up by VIN, or pick it out of the line-up. It stays here afterwards, so the parts and the prices you see are the ones that fit it.'));
      nowHost.appendChild(none);
      return;
    }

    var card = el('div', 'fx-rc__now');
    card.appendChild(thumb(top, 'fx-rc__shot', liveImg(top)));
    var meta = el('div', 'fx-rc__meta');
    var nm = el('p', 'fx-rc__name', nameOf(top));
    meta.appendChild(nm);
    var sub = [];
    if (top.nick) sub.push((top.year ? top.year + ' ' : '') + top.model);
    if (top.vin) sub.push('VIN ' + top.vin);
    if (top.range) sub.push(top.range);
    meta.appendChild(el('p', 'fx-rc__sub', sub.join(' · ')));
    meta.appendChild(nameBtn(top, nm));
    var figs = el('div', 'fx-rc__figs');
    meta.appendChild(figs);
    fillFigs(figs, top.model);
    var go = el('button', 'fx-rc__go', 'Find Parts');
    go.type = 'button';
    go.addEventListener('click', function () { commit(top); });
    meta.appendChild(go);
    card.appendChild(meta);
    nowHost.appendChild(card);
    if (animate) {
      card.classList.remove('is-swap');
      void card.offsetWidth;
      card.classList.add('is-swap');
    }

    var rest = list.filter(function (r) { return r.id !== top.id; });
    if (!rest.length) {
      var e = el('div', 'fx-rc__empty');
      e.appendChild(el('h5', null, 'No other trailers yet'));
      e.appendChild(el('p', null, 'Trailers you look up collect here, so you can move between them without typing a VIN twice.'));
      listHost.appendChild(e);
      return;
    }
    listHost.appendChild(el('p', 'fx-rc__lbl', 'Recent'));
    var rows = el('div', 'fx-rc__rows');
    rest.forEach(function (rec) {
      var r = el('div', 'fx-rc__r');
      r.setAttribute('role', 'button');
      r.tabIndex = 0;
      r.appendChild(thumb(rec, 'fx-rc__thumb'));
      var mid = el('span', 'fx-rc__mid');
      var nm2 = el('p', 'fx-rc__rname', nameOf(rec));
      mid.appendChild(nm2);
      var m = el('p', 'fx-rc__rmeta');
      if (rec.kind === 'browse') m.appendChild(el('span', 'fx-rc__tag', 'Browsed'));
      var bits = [];
      if (rec.kind !== 'browse' && rec.vin) bits.push('VIN ' + rec.vin);
      bits.push(rec.nick ? (rec.year ? rec.year + ' ' : '') + rec.model : ago(rec.at));
      m.appendChild(document.createTextNode(bits.join(' · ')));
      mid.appendChild(m);
      r.appendChild(mid);
      var acts = el('span', 'fx-rc__acts');
      acts.appendChild(pencil(rec, nm2));
      var del = el('button', 'fx-rc__del');
      del.type = 'button';
      del.title = 'Remove from this list';
      del.setAttribute('aria-label', 'Remove ' + nameOf(rec));
      del.addEventListener('click', function (e) {
        e.stopPropagation();
        write(KEY, log().filter(function (x) { return x.id !== rec.id; }));
        if (viewing && viewing.id === rec.id) viewing = null;
        render(false);
      });
      acts.appendChild(del);
      r.appendChild(acts);

      function promote() {
        viewing = rec;
        render(true);
        if (nowHost.firstChild) nowHost.firstChild.scrollIntoView({ block: 'nearest' });
      }
      r.addEventListener('click', promote);
      r.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); promote(); }
      });
      rows.appendChild(r);
    });
    listHost.appendChild(rows);
  }

  function buildDrawer() {
    root = el('div', 'fx-rc');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-label', 'My trailer');
    var scrim = el('div', 'fx-rc__scrim');
    scrim.addEventListener('click', close);
    var panel = el('div', 'fx-rc__panel');

    var head = el('div', 'fx-rc__head');
    head.appendChild(el('h4', null, 'My trailer'));
    var x = el('button', 'fx-rc__x');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', close);
    head.appendChild(x);
    panel.appendChild(head);

    var body = el('div', 'fx-rc__body');
    nowHost = el('div');
    listHost = el('div');
    body.appendChild(nowHost);
    body.appendChild(listHost);
    panel.appendChild(body);

    var foot = el('div', 'fx-rc__foot');
    var vinBtn = el('button', 'fx-rc__btn', 'Search by VIN');
    vinBtn.type = 'button';
    vinBtn.addEventListener('click', function () {
      close();
      var input = document.querySelector('.vin-hero-vin-input');
      if (input) {
        input.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(function () { input.focus(); input.select(); }, 350);
      } else {
        /* From another page: ask for an empty VIN search. A plain '/' let
           the extension reopen whatever the modal last showed, which could
           be the Model & year tab. */
        window.location.href = '/?vin_open=new';
      }
    });
    var browse = el('button', 'fx-rc__lnk', 'Browse all models');
    browse.type = 'button';
    browse.addEventListener('click', function () {
      close();
      var pick = document.querySelector('.vin-hero-pick');
      if (pick) pick.scrollIntoView({ block: 'start', behavior: 'smooth' });
      else window.location.href = '/';
    });
    foot.appendChild(vinBtn);
    foot.appendChild(browse);
    panel.appendChild(foot);

    root.appendChild(scrim);
    root.appendChild(panel);
    document.body.appendChild(root);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
    built = true;
  }

  /* The slide out panel belongs to fx-shell.js, which has no idea this drawer
     exists. Rather than export a handle for one caller, close it the same way
     it opens: the class, the scroll lock and the burger's state. */
  function closeTray() {
    document.querySelectorAll('.fx-panel.is-open').forEach(function (p) {
      p.classList.remove('is-open');
    });
    document.body.style.overflow = '';
    document.querySelectorAll('[data-fx-burger]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  /* Capture phase and on document, so it survives the header re-rendering, and
     so it runs before fx-shell.js's own handler on the same element. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest
      ? e.target.closest('.fx-hdr__act .fx-vin, .fx-panel .fx-vin')
      : null;
    if (!t) return;
    /* Nothing to show yet: the panel copy is a plain call to action at that
       point, so let it go to the VIN field. */
    if (!log().length && !current()) return;
    e.preventDefault();
    e.stopPropagation();
    closeTray();
    if (!built) buildDrawer();
    open();
  }, true);

  /* What counts as choosing a trailer: touching any of the filters, opening a
     model from the line-up, or pressing a Find Parts anywhere. Not arriving,
     and not the extension setting its own defaults, which is what isTrusted
     separates: a dispatched event reports false, a finger or a keyboard
     reports true. */
  function markChosen() { chosen = true; }
  document.addEventListener('change', function (e) {
    if (e.isTrusted && e.target && e.target.tagName === 'SELECT') markChosen();
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target || !e.target.closest) return;
    if (e.target.closest('.ident-card, [data-ident-find], .vin-hero-pickbar, .ident-sheet .is-primary')) markChosen();
  }, true);

  function tick() {
    frame = 0;
    if (!built) buildDrawer();
    var rec = current();
    if (rec && (rec.kind === 'vin' || chosen)) {
      var top = log()[0];
      if (!top || top.id !== rec.id) {
        remember(rec);
        viewing = null;
        if (root && root.classList.contains('is-open')) render(false);
      }
    }
  }

  function schedule() { if (!frame) frame = setTimeout(tick, 16); }

  function start() {
    tick();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    setInterval(tick, 800);

    try {
      var pend = window.sessionStorage.getItem(PENDING);
      if (pend) {
        window.sessionStorage.removeItem(PENDING);
        setTimeout(function () { replayVin(pend); }, 600);
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
